import axios from 'axios'

export const getNotification = (period) => {
    return axios.get(`/v2/news?period=${period}`);
}
